import React from "react";
import StatCard from "../../StatCard";
import Card from "../../ui/Card";

// =============================================================================
// DIALER STATS
// =============================================================================
// PURPOSE: Dashboard section for dialer role — call volume and activity metrics.
//
// VISIBILITY: Only shown to dialers (see roleConfig.ts).
//
// DISPLAYED METRICS:
// - Total dials (outbound call attempts)
// - Dials per day (daily average)
// - Sets booked, calls booked (conversions from dials)
// - Show up rate
//
// DESIGN DECISION: Dialers are measured on speed and volume, not revenue.
// Financial graph is excluded (placeholder card) to keep focus on activity metrics.
// This is the leanest dashboard view — dialers have the narrowest data visibility.
// =============================================================================

interface DialerStatsProps {
  kpis: {
    dials: number;
    dialsPerDay: number;
    dealsClosed: number;
    callsBooked: number;
    showUpRate: number;
  };
  getSamples: (key: string) => any[];
}

const DialerStats: React.FC<DialerStatsProps> = ({ kpis, getSamples }) => (
  <div className="space-y-4 sm:space-y-6">
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-6">
      <StatCard
        title="Total Dials"
        value={kpis.dials > 0 ? kpis.dials.toString() : "--"}
        subtext={kpis.dials === 0 ? "No dial data" : undefined}
        metricKey="dials"
        getSamples={getSamples}
      />
      <StatCard
        title="Dials per Day"
        value={kpis.dialsPerDay > 0 ? kpis.dialsPerDay.toString() : "--"}
        metricKey="dialsPerDay"
        getSamples={getSamples}
      />
      <StatCard
        title="Sets Booked"
        value={kpis.dealsClosed.toString()}
        metricKey="dealsClosed"
        getSamples={getSamples}
      />
      <StatCard
        title="Calls Booked"
        value={kpis.callsBooked.toString()}
        metricKey="callsBooked"
        getSamples={getSamples}
      />
      <StatCard
        title="Show Up Rate"
        value={`${kpis.showUpRate.toFixed(1)}%`}
        metricKey="showUpRate"
        getSamples={getSamples}
      />
    </div>
    <Card className="bg-black/[0.03] text-center py-12 text-glass-muted border-dashed">
      Dialer Focus: Speed &amp; Volume (Graph Excluded)
    </Card>
  </div>
);

export default DialerStats;
